module.exports = __webpack_public_path__ + "img/type-strikethrough.fba86a16.svg";